import { render, staticRenderFns } from "./SubLocationsList.vue?vue&type=template&id=011192f6&"
import script from "./SubLocationsList.vue?vue&type=script&lang=js&"
export * from "./SubLocationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports